import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Wizard from "@/pages/Wizard";
import Admin from "@/pages/Admin";
import DepartmentSheet from "@/pages/DepartmentSheet";
import ConfirmQuote from "@/pages/ConfirmQuote";
import TablesCalendar from "@/pages/TablesCalendar";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Wizard />} />
          <Route path="/riprendi/:token" element={<Wizard />} />
          <Route path="/gestione" element={<Admin />} />
          <Route path="/scheda/:token" element={<DepartmentSheet />} />
          <Route path="/conferma/:token" element={<ConfirmQuote />} />
          <Route path="/tavoli/:token" element={<TablesCalendar />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
